import React from 'react';
import { formatAmount } from "$ACTIONS/util";
import { Popover } from "antd";
import { isToggleOn } from "$ACTIONS/balanceRequest";

const TopOfWithdrawalInfo = ({ onClick, storeBalanceV2Result }) => {
    storeBalanceV2Result = storeBalanceV2Result || {}
    const isToggleOff = !isToggleOn(storeBalanceV2Result);
    return (
        <>
            {isToggleOff ?
            <div className="top-withdraw-inf-card">
                <div className="top-withdraw-inf-row">
                    <div className="top-withdraw-inf-label">
                        总余额
                    </div>
                    <div className="top-withdraw-inf-amount" style={isToggleOff ? {paddingRight:0} : {}}>￥ {formatAmount(storeBalanceV2Result.totalBalance)}</div>
                </div>
            </div>
            :
            <div className="top-withdraw-inf-card">
                <div className="top-withdraw-inf-row">
                    <div className="top-withdraw-inf-label">
                        可提款金額
                        <span className="top-withdraw-inf-subtext">(提現流水將在結算后的 15 分鐘內更新)</span>
                    </div>
                    <div className="top-withdraw-inf-amount">¥ {formatAmount(storeBalanceV2Result.withdrawableBalance)}</div>
                </div>
                <div className="top-withdraw-inf-row">
                    <div className="top-withdraw-inf-label">未完成流水金額
                        <Popover content="完成流水要求，以解锁符合条件的存款和优惠金额至可提款金额" overlayStyle={{ maxWidth: "240px", fontSize:"14px" }} placement="bottom">
                            <i></i>
                        </Popover>
                    </div>
                    <div className="top-withdraw-inf-amount" style={{cursor:'pointer'}} onClick={onClick}>¥ {formatAmount(storeBalanceV2Result.totalContractBalance)}</div>
                </div>
            </div>
            }
        </>
    );
};

export default TopOfWithdrawalInfo;
